import { useEffect, useMemo, useState } from 'react';
import './ActivityPage.css';
import './ThirteenthAnniversaryPage.css';

const eventStart = new Date('2026-08-17T18:00:00+08:00').getTime();
const eventEnd = new Date('2026-08-31T23:59:00+08:00').getTime();

const rewards = [
  ['01', '纪念币 ×130', 'UU物质 ×32', '纳米聚合体 ×4 · 庆典券 ×1'],
  ['02', '纪念币 ×30', 'UU物质 ×16', '高级合金板 ×4'],
  ['03', '纪念币 ×50', 'UU物质 ×24', '高级纳米聚合体 ×2 · 庆典券 ×1'],
  ['04', '纪念币 ×30', '拾叁岁序食材箱 ×1', '—'],
  ['05', '纪念币 ×50', 'UU物质 ×24', '—'],
  ['06', '纪念币 ×30', '中级量子刃晶 ×4 · 电动马达 ×3', '庆典券 ×1'],
  ['07', '纪念币 ×50', 'UU物质 ×32', '—'],
  ['08', '纪念币 ×30', '高级暗物质线束 ×2', '—'],
  ['09', '纪念币 ×50', '高级量子刃晶 ×2', '庆典券 ×1'],
  ['10', '纪念币 ×30', '拾叁岁序食材箱 ×1', '—'],
  ['11', '纪念币 ×50', '高级脉冲核芯 ×2', '—'],
  ['12', '纪念币 ×30', '高级星锻合金 ×2', '庆典券 ×1'],
  ['13', '纪念币 ×130', 'UU物质 ×48 · 周年星匣 ×1', '庆典券 ×1'],
  ['14', '纪念币 ×140', 'UU物质 ×32', '珍稀资源箱 ×1'],
];

const weapons = [
  ['余烬重锤', '近战 · 熔岩', '地震波 + 径向熔岩喷射'],
  ['极光弓', '远程 · 光谱', '贝塞尔曲线分裂追踪箭'],
  ['寒冬吐息', '法术 · 冰霜', '扇形冰息 + 速度冻结'],
  ['流星陨落', '法术 · 陨石', '陨石坠落 + 镜头震动'],
];

const qqGroups = [
  { name: '官方1群', number: '616444639', link: 'https://qm.qq.com/q/juPbcm3eBa' },
  { name: '官方2群', number: '874462523', link: 'https://qm.qq.com/q/MTyzQHvBG6' },
  { name: '官方3群', number: '182670005', link: 'https://qm.qq.com/q/c6lUVm39fO' },
  { name: '官方4群', number: '531581648', link: 'https://qm.qq.com/q/Wpegbnzr0o' },
  { name: '官方5群', number: '339605679', link: 'https://qm.qq.com/q/kIN0OFP6fK' },
  { name: '官方6群', number: '414554298', link: 'https://qm.qq.com/q/v8vGHbQNBm' },
];

function getCountdown(now) {
  if (now > eventEnd) return { label: '庆典已落幕', value: '感谢十三年同行', state: 'ended' };
  if (now >= eventStart) return { label: '拾叁 · 岁序庆典进行中', value: '现在登录 · 点亮坐标', state: 'live' };
  const gap = eventStart - now;
  const days = Math.floor(gap / 86400000);
  const hours = Math.floor((gap % 86400000) / 3600000);
  const minutes = Math.floor((gap % 3600000) / 60000);
  const seconds = Math.floor((gap % 60000) / 1000);
  return {
    label: '距离庆典开启',
    value: `${String(days).padStart(2, '0')}天 ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`,
    state: 'counting',
  };
}

function ThirteenthAnniversaryPage() {
  const [now, setNow] = useState(Date.now());
  const [navOpen, setNavOpen] = useState(false);
  const countdown = useMemo(() => getCountdown(now), [now]);

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    const oldTitle = document.title;
    const description = document.querySelector('meta[name="description"]');
    const oldDescription = description?.getAttribute('content');
    document.title = '拾叁 · 岁序庆典｜地球天空十三周年';
    description?.setAttribute('content', '地球天空十三周年庆典：14 日签到、周年礼盒、纪念币商店、限定祈愿与核心战争联赛。');

    const setMeta = (property, content) => {
      let node = document.querySelector(`meta[property="${property}"]`);
      if (!node) {
        node = document.createElement('meta');
        node.setAttribute('property', property);
        document.head.appendChild(node);
      }
      node.setAttribute('content', content);
    };
    setMeta('og:title', '拾叁 · 岁序庆典｜地球天空十三周年');
    setMeta('og:description', '从第一条航线亮起，到无数坐标被点亮。十三年后，我们仍在欢呼。');
    setMeta('og:image', `${window.location.origin}${process.env.PUBLIC_URL}/assets/thirteenth-anniversary.png`);

    return () => {
      window.clearInterval(timer);
      document.title = oldTitle;
      if (oldDescription) description?.setAttribute('content', oldDescription);
    };
  }, []);

  useEffect(() => {
    const targets = [...document.querySelectorAll('.anniversary-page .anniversary-reveal')];
    if (!('IntersectionObserver' in window)) {
      targets.forEach((target) => target.classList.add('is-visible'));
      return undefined;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });
    targets.forEach((target) => observer.observe(target));
    return () => observer.disconnect();
  }, []);

  return (
    <main className="event-page anniversary-page">
      <nav className="event-nav" aria-label="十三周年活动导航">
        <a className="event-brand" href="/" aria-label="返回地球天空官网">
          <img src={`${process.env.PUBLIC_URL}/assets/logo.png`} alt="" />
        </a>
        <button
          className="event-nav-toggle"
          type="button"
          aria-expanded={navOpen}
          aria-controls="anniversary-nav-links"
          onClick={() => setNavOpen((open) => !open)}
        >
          <span /><span /><span /><b className="sr-only">打开导航</b>
        </button>
        <div id="anniversary-nav-links" className={`event-nav-links ${navOpen ? 'is-open' : ''}`}>
          <a href="#anniversary-story" onClick={() => setNavOpen(false)}>庆典序章</a>
          <a href="#anniversary-overview" onClick={() => setNavOpen(false)}>活动速览</a>
          <a href="#anniversary-signin" onClick={() => setNavOpen(false)}>岁序签到</a>
          <a href="#anniversary-gifts" onClick={() => setNavOpen(false)}>周年礼盒</a>
          <a href="#anniversary-schedule" onClick={() => setNavOpen(false)}>活动日程</a>
        </div>
      </nav>

      <header className="event-hero anniversary-hero">
        <div
          className="event-hero-image"
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/thirteenth-anniversary.png)` }}
          role="img"
          aria-label="地球天空十三周年庆典：烟花、浮空岛与周年蛋糕塔"
        />
        <div className="event-hero-shade" />
        <div className="event-hero-meta">
          <span className="eyebrow"><i /> EARTHSKY · ANNIVERSARY XIII</span>
          <span className="hero-status">2013 — 2026 · 十三周年</span>
        </div>
        <div className={`countdown-panel ${countdown.state}`}>
          <span>{countdown.label}</span>
          <strong>{countdown.value}</strong>
          <small>2026.08.17 18:00 — 08.31 23:59</small>
        </div>
        <a className="hero-scroll" href="#anniversary-story"><span>进入庆典</span><i /></a>
      </header>

      <section className="event-section anniversary-story anniversary-reveal" id="anniversary-story">
        <span className="section-index">01 / THIRTEEN YEARS</span>
        <div className="anniversary-story-grid">
          <div>
            <p className="eyebrow">拾叁 · 岁序庆典</p>
            <h1>从第一条航线亮起，<br />到无数坐标被点亮。</h1>
          </div>
          <div>
            <p>2013 至今，已经过去十三年。有人从空岛出发，有人在这里停下；有人离开很久，也有人始终没有换过坐标。</p>
            <p>如今，熟悉的航站楼再次亮灯。我们以签到、礼盒、联赛与祈愿，邀请每一位新老玩家回到这条共同走过的航线。</p>
            <blockquote>十三年后，我们仍在欢呼。</blockquote>
          </div>
        </div>
        <div className="anniversary-stats">
          <div><strong>13</strong><span>共同走过的年岁</span></div>
          <div><strong>14</strong><span>可完成签到天数</span></div>
          <div><strong>1,620</strong><span>满勤纪念币</span></div>
          <div><strong>4</strong><span>周年幻想武器</span></div>
        </div>
      </section>

      <section className="anniversary-band" id="anniversary-overview">
        <div className="event-section">
          <div className="section-heading anniversary-reveal">
            <div>
              <span className="section-index">02 / CELEBRATION MAP</span>
              <p className="eyebrow">活动速览</p>
              <h2>十五日开放，十四日满勤</h2>
            </div>
            <p>活动于 8 月 17 日 18:00 开启，开放至 8 月 31 日。按下 ESC，通过左下角“签到”进入周年活动。</p>
          </div>
          <div className="anniversary-feature-grid anniversary-reveal">
            <article><b>01</b><small>DAILY ROUTE</small><h3>14 日签到</h3><p>每日领取纪念币与空岛物资，累计 3 / 7 / 14 天解锁额外奖励。</p></article>
            <article><b>02</b><small>LUCKY DROP</small><h3>天降幸运</h3><p>8 月 20—22 日连续三晚，从全服在线玩家中抽取星髓与新武器。</p></article>
            <article><b>03</b><small>LEAGUE RETURNS</small><h3>小游戏联赛</h3><p>核心战争超级联赛回归，参与到底即可获得永久称号与资源。</p></article>
            <article><b>04</b><small>ANNIVERSARY WISH</small><h3>限定祈愿</h3><p>使用周年庆典券参与“拾叁 · 岁序庆典”限定祈愿。</p></article>
          </div>

          <div className="lucky-panel anniversary-reveal">
            <div>
              <small>LUCKY SIGNAL / 21:00</small>
              <h3>连续三晚，幸运降临</h3>
              <p>8 月 20、21、22 日每晚采用同一奖池。运营组将同步公布在线名单与获奖结果；同一 IP 仅按一人中奖计算。</p>
            </div>
            <div className="lucky-dates">
              <div className="lucky-schedule"><b>08.20 · 08.21 · 08.22</b><small>每晚 21:00 · 统一奖池</small></div>
              <span><b>新武器自选箱</b>每晚抽取 1 人</span>
              <span><b>50 星髓</b>每晚抽取 2 人</span>
              <span><b>30 星髓</b>每晚抽取 3 人</span>
            </div>
          </div>
        </div>
      </section>

      <section className="event-section anniversary-signin" id="anniversary-signin">
        <div className="section-heading anniversary-reveal">
          <div>
            <span className="section-index">03 / AGE ROUTE</span>
            <p className="eyebrow">14 日签到 · 岁序航线</p>
            <h2>每天点亮一个坐标</h2>
          </div>
          <p>纪念币签到后直接到账；实物奖励通过空岛子服邮件发放，礼盒领取后自动进入仓库。本活动不支持补签。</p>
        </div>
        <div className="anniversary-totals anniversary-reveal">
          <div><strong>830</strong><span>每日签到纪念币</span></div>
          <div><strong>790</strong><span>累计档位纪念币</span></div>
          <div><strong>208</strong><span>全程 UU 物质</span></div>
        </div>
        <div className="anniversary-milestones anniversary-reveal">
          <div><b>累计 3 天</b><span>纪念币 ×130 · 机器升级芯片 · 庆典券</span></div>
          <div><b>累计 7 天</b><span>纪念币 ×260 · 发电机 / 储能升级芯片 · 庆典券</span></div>
          <div><b>累计 14 天</b><span>纪念币 ×400 · 周年武器自选箱 · 超级纳米聚合体 · 庆典券 ×2</span></div>
        </div>
        <details className="anniversary-reward-details anniversary-reveal">
          <summary>查看 14 日每日奖励 <span>+</span></summary>
          <div>
            <div className="anniversary-reward-header" aria-hidden="true">
              <b>签到天数</b><b>纪念币</b><b>当日物资</b><b>额外奖励</b>
            </div>
            {rewards.map(([day, coin, material, extra]) => (
              <p key={day}><b>DAY {day}</b><span>{coin}</span><span>{material}</span><span>{extra}</span></p>
            ))}
          </div>
        </details>
      </section>

      <section className="anniversary-band" id="anniversary-gifts">
        <div className="event-section">
          <div className="section-heading anniversary-reveal">
            <div>
              <span className="section-index">04 / TERMINAL GIFTS</span>
              <p className="eyebrow">周年礼盒</p>
              <h2>航站楼的礼物</h2>
            </div>
            <p>四类周年礼盒会自动进入仓库。随机、七选三、十三选六与武器四选一，对应不同的庆典补给方式。</p>
          </div>
          <div className="anniversary-box-grid anniversary-reveal">
            <article><b>星</b><small>RANDOM</small><h3>周年星匣</h3><p>随机获得纪念币、UU 物质、高级材料、食材箱、珍稀箱或庆典券。</p></article>
            <article><b>珍</b><small>SELECT 3 / 7</small><h3>珍稀资源箱</h3><p>从七类高级工业产物与庆典券中任选三项。</p></article>
            <article><b>味</b><small>SELECT 6 / 13</small><h3>岁序食材箱</h3><p>从十三种周年食材中任选六种，每种获得 64 个。</p></article>
            <article><b>武</b><small>SELECT 1 / 4</small><h3>周年武器箱</h3><p>累计签到 14 天必得，请在领取前确认背包空间。</p></article>
          </div>
          <div className="anniversary-weapons anniversary-reveal">
            {weapons.map(([name, type, desc], index) => (
              <article key={name}><i>{String(index + 1).padStart(2, '0')}</i><small>{type}</small><h3>{name}</h3><p>{desc}</p></article>
            ))}
          </div>
        </div>
      </section>

      <section className="event-section anniversary-commerce">
        <div className="anniversary-shop anniversary-reveal">
          <div>
            <span className="section-index">05 / COMMEMORATIVE STORE</span>
            <p className="eyebrow">纪念币商店</p>
            <h2>把岁序留作纪念</h2>
            <p>空岛与大厅分别开放十三周年纪念商店。通过 ESC 右下角“商店”进入，部分商品设有每日、每周或每月限购。</p>
          </div>
          <ul>
            <li><span>周年星匣</span><b>150</b></li>
            <li><span>岁序食材箱</span><b>80</b></li>
            <li><span>珍稀资源箱</span><b>300</b></li>
            <li><span>十三周年纪念章</span><b>30</b></li>
            <li><span>庆典烟花</span><b>2</b></li>
            <li><span>庆典蛋糕</span><b>5</b></li>
          </ul>
        </div>
        <div className="anniversary-wish anniversary-reveal">
          <div className="anniversary-wish-mark">
            <span>06</span>
            <small>LIMITED WISH</small>
          </div>
          <div className="anniversary-wish-content">
            <h2>拾叁 · 岁序庆典<br />限定祈愿</h2>
            <div>
              <p>活动期间使用周年庆典券参与。通过 ESC → 祈愿 → 左侧限定奖池进入，单抽消耗 1 张庆典券。</p>
              <small>周年付费礼包暂未开放；具体概率、保底与每日补给以游戏内页面为准。</small>
            </div>
          </div>
        </div>
      </section>

      <section className="anniversary-league">
        <div className="event-section anniversary-reveal">
          <div className="league-date"><strong>08.22</strong><span>21:00 · 周六</span></div>
          <div className="league-copy"><small>ANNIHILATION SUPER LEAGUE</small><h2>核心战争超级联赛回归</h2><p>比赛地点：地球天空中国版比赛专用服。所有坚持完成比赛的玩家均可获得永久称号、天空水晶与以太，获胜队伍及单项表现另有奖励。</p></div>
          <div className="league-prizes"><span>参与称号「终界行者」永久</span><span>获胜称号「核心王者」60 天</span><span>最后一击「核心猎手」60 天</span><span>杀敌第一「神·战争机器」60 天</span></div>
        </div>
      </section>

      <section className="event-section anniversary-schedule" id="anniversary-schedule">
        <div className="section-heading anniversary-reveal">
          <div><span className="section-index">07 / EVENT SCHEDULE</span><p className="eyebrow">活动日程</p><h2>熟悉的航站楼，再次亮灯</h2></div>
          <p>如遇特殊情况，活动时间可能顺延或提前，请以实际开服公告与游戏内显示为准。</p>
        </div>
        <div className="anniversary-schedule-grid anniversary-reveal">
          <div><time>08.17 <small>18:00</small></time><b>周年活动开启</b><span>签到、礼盒、商店与限定祈愿同步开放</span></div>
          <div><time>08.20—22 <small>21:00</small></time><b>天降幸运</b><span>连续三晚抽取在线玩家</span></div>
          <div><time>08.22 <small>21:00</small></time><b>核心战争联赛</b><span>比赛专用服集结</span></div>
          <div><time>08.31 <small>23:59</small></time><b>周年活动结束</b><span>礼盒建议在结束后 7 天内使用</span></div>
        </div>
      </section>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-logo"><img src={`${process.env.PUBLIC_URL}/assets/big_logo.png`} alt="地球天空" /></div>
          <div className="footer-content">
            <div className="footer-left"><p className="footer-slogan">地球天空运营组致力于为您带来快乐！</p><p className="footer-tagline">专业 / 效率 / 温情</p></div>
            <div className="footer-right"><h4 className="footer-section-title">玩家社群</h4><div className="footer-groups">
              {qqGroups.map((group) => <a key={group.number} href={group.link} target="_blank" rel="noopener noreferrer" className="footer-group-row"><span className="group-name">地球天空{group.name}：</span><span className="group-id">{group.number}</span></a>)}
            </div></div>
          </div>
        </div>
        <div className="footer-bottom"><span className="footer-copyright">© {new Date().getFullYear()} 地球天空 SkyPixel. All rights reserved.</span><span className="footer-divider">|</span><a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer" className="footer-icp">粤ICP备15051067号-1</a></div>
      </footer>
    </main>
  );
}

export default ThirteenthAnniversaryPage;
